import { render, staticRenderFns } from "./TransferofHCP.vue?vue&type=template&id=72f4f9fb&scoped=true&"
import script from "./TransferofHCP.vue?vue&type=script&lang=js&"
export * from "./TransferofHCP.vue?vue&type=script&lang=js&"
import style0 from "./TransferofHCP.vue?vue&type=style&index=0&id=72f4f9fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4f9fb",
  null
  
)

export default component.exports